import './assets/css/com.css';
import '../theme/index.css';
import './assets/css/element-ui-style.css';
import './assets/css/iconCss/demo.css';
import './assets/css/iconCss/iconfont.css';

import Vue from 'vue'
import ElementUI from 'element-ui';
import App from './App.vue'
import router from './router/index'
import store from './store/index'

import ErrorTemplate from './components/errorTemplate'

Vue.config.productionTip = false

Vue.use(ElementUI);


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


Vue.component('ErrorTemplate', ErrorTemplate);
